import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { style: {"width":"100%"} }
const _hoisted_2 = {
  key: 0,
  class: "row-top mtop-06"
}
const _hoisted_3 = { class: "row-top" }
const _hoisted_4 = {
  key: 1,
  class: "pad-s"
}
const _hoisted_5 = {
  key: 1,
  class: "mtop-10 row-top flexwrap gap-30",
  style: {"row-gap":"1.5rem"}
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { key: 4 }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = {
  key: 2,
  class: "line-h mtop-25"
}
const _hoisted_13 = { class: "table columns mtop-04" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { class: "row w-full" }
const _hoisted_16 = { class: "row w-full" }
const _hoisted_17 = { class: "bg-modal" }
const _hoisted_18 = { class: "w-full row gap-06" }
const _hoisted_19 = { class: "mtop-10 subColumns" }
const _hoisted_20 = {
  style: {"grid-column":"right"},
  class: "row"
}
const _hoisted_21 = { class: "bg-modal w-maxC" }
const _hoisted_22 = { class: "bg-modal w-maxC" }
const _hoisted_23 = { style: {"grid-column":"right"} }
const _hoisted_24 = { class: "bg-modal h-full scroll-height" }
const _hoisted_25 = { style: {"grid-column":"right"} }
const _hoisted_26 = { class: "bg-modal h-full scroll-height" }
const _hoisted_27 = {
  style: {"grid-column":"right","width":"23rem"},
  class: "row gap-04"
}
const _hoisted_28 = {
  style: {"grid-column":"right"},
  class: "row"
}
const _hoisted_29 = { style: {"width":"20rem"} }
const _hoisted_30 = {
  style: {"grid-column":"right"},
  class: "row gap-04 mtop-04"
}
const _hoisted_31 = {
  style: {"grid-column":"right"},
  class: "row"
}
const _hoisted_32 = { style: {"width":"20rem"} }
const _hoisted_33 = {
  key: 1,
  class: "pad-m"
}
const _hoisted_34 = { class: "pad-m w-full" }
const _hoisted_35 = { class: "col w-full" }
const _hoisted_36 = { class: "row w-full gap-02" }
const _hoisted_37 = { class: "bg-modal w-maxC" }
const _hoisted_38 = { class: "bg-modal w-maxC" }
const _hoisted_39 = {
  key: 5,
  class: "row mleft-04"
}
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { class: "row pad-m mleft-auto" }
const _hoisted_42 = {
  key: 0,
  class: "row-end pad-m mleft-auto",
  style: {"padding-top":"0"}
}
const _hoisted_43 = { class: "w-full row pright-16px" }
const _hoisted_44 = {
  key: 3,
  class: "row-top mtop-06"
}
const _hoisted_45 = { class: "bg-modal h-full scroll-height" }
const _hoisted_46 = { class: "row-top" }

import editAppUserPreferences from '@/views/patientMain/editAppUserPreferences.vue'
import docLuBillPreferencesAdd from './docLuBillPreferencesAdd.vue';
import docLuBillCustomActsSettings from './docLuBillCustomActsSettings.vue';
import { useToast } from 'primevue';

import { ref, computed, nextTick, watch, onMounted } from 'vue';
import gen from "@/functions/general.js";
import { useInteropLuStore } from '@/stores/interopLu';
import { apiDateString} from "@/api/apicommon";
import { useAppUserStore } from '@/stores/appUser';
import patientapi from "@/api/patientapi";
import { useCurrentEntryStore } from '@/stores/currentEntry';
import { useI18n } from 'vue-i18n';
import { DateFormat } from "@/models/share.model";
import { format, differenceInDays, isSameDay } from 'date-fns';
import { ApiError, AccountingApi, InstituteApi, HealthProResponse } from '@/apiGenerate/medserver';
import { medServerApiConfig } from '@/config/medserver-api.config';
import { toastError } from '@/utils/toast-utils';
import PersonService from "@/services/PersonService";


export default /*@__PURE__*/_defineComponent({
  __name: 'docLuBillAddOn',
  props: /*@__PURE__*/_mergeModels({
  patientDocument: {
    type: Object,
    required: true,
  },
}, {
    "currFinancialGroup": {},
    "currFinancialGroupModifiers": {},
  }),
  emits: ["update:currFinancialGroup"],
  setup(__props) {

const accountingApi = new AccountingApi(medServerApiConfig);
const instituteApi = new InstituteApi(medServerApiConfig);

const props = __props;

const toast = useToast();
const {t} = useI18n();
const appUserStore = useAppUserStore();
const interopLuStore = useInteropLuStore();
const currentEntryStore = useCurrentEntryStore();

const dropd = ref("");
const dropd2 = ref("");
const hospiStartDate = ref(null);
const hospiEndDate = ref(null);
const newHospiAct = ref(null);
const editedAct = ref(null);

const changeHospiDate = (newDates: Date[]) => {
  hospiStartDate.value = newDates[0];
  hospiEndDate.value = newDates[1] ? newDates[1] : null;
  if (!hospiStartDate.value || !hospiEndDate.value) return;
  // Sanity check: ensure duration is not more than 300 days
  const durationInDays = differenceInDays(hospiEndDate.value, hospiStartDate.value);
  if (durationInDays > 300) {
    toastError(toast, {
      summary: t('common.toast.error'),
      detail: t('error.HOSPI_DURATION_TOO_LONG', { days: 300 })
    });
    hospiStartDate.value = null;
    hospiEndDate.value = null;
  }  
}

const allStudents = ref<HealthProResponse[]>([]);
async function getStudentsByInstitute() {
  if (!appUserStore.currentHealthGroupMembership) {
    allStudents.value = [];
    return;
  }
  try {
    const currentIwr = appUserStore.currentHealthGroupMembership.instituteWithRole;
      const result = await instituteApi.getStudentsByInstitute({
        instituteId: currentIwr.instituteWithRoleId
      });
    allStudents.value = result;
  } catch (e) {
    const error = e as ApiError;
    toastError(toast, {
      summary: t('common.toast.error'),
      detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
    });
    allStudents.value = [];
  }
}

const currFinancialGroup = _useModel(__props, 'currFinancialGroup');
const allHealthPros = ref<HealthProResponse[]>([]);

async function getHealthProsByFinancialGroup() {
  if (!currFinancialGroup.value?.id) {
    allHealthPros.value = [];
    return;
  }
  try {
    const result = await accountingApi.getHealthProByFinancialGroup({
      financialGroupId: currFinancialGroup.value.id
    });
    allHealthPros.value = result;
  } catch (error: ApiError) {
    toastError(toast, {
      summary: t('common.toast.error'),
      detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
    });
    allHealthPros.value = [];
  }
}
function getHealthProShortName(act) {
  const misaNumber = act.luHealthProNumber;
  if (!allHealthProsAndStudents.value.length) return misaNumber;
  const pwr = allHealthProsAndStudents.value.find(item => item.misaNumber === misaNumber);
  if (!pwr) return misaNumber;
  return `${pwr.lastName} ${pwr.firstName?.charAt(0)}.`;
}

function getHealthProName(act) {
  const misaNumber = act.luHealthProNumber;
  if (!allHealthProsAndStudents.value.length) return misaNumber;
  const pwr = allHealthProsAndStudents.value.find(item => item.misaNumber === misaNumber);
  if (!pwr) return misaNumber;
  return PersonService.formatName(pwr.lastName, pwr.firstName);
}

function isInpatientDayExceptFirst(act) {
  return act.isHospiCode && !act.isFirstHospiDay;
}

const allHealthProsAndStudents = computed<HealthProResponse[]>(() => {
  return [...allHealthPros.value, ...allStudents.value];
});

const searchInputRef = ref(null);
const searchInput = ref("");

const suffixList = ref([]);

const currPatientDoc = ref(props.patientDocument)
const currLuBill = ref(currPatientDoc.value.luBill)

const filteredActs = computed(() => {
  let ret = []
  const maxItems = 50

  let searchString = searchInput.value
  searchString = searchString.trim()
  if (searchString.length <= 1) return ret
  searchString = searchString.toUpperCase()

  const searchParts = searchString.split(" ")
  allActesValues.value.some(luAct => {
    if (ret.length >= maxItems) {return true}
    const matchesSearch = searchParts.every(part => luAct.searchTerm.includes(part))
    if (matchesSearch) {ret.push(luAct)}
    return false
  })
  return ret
})


async function updateLuBillAdditionalInfo(info) {
  const luBillId = currLuBill.value.luBillId;
  const additionalInfoCode = info?.code || "";
  dropd2.value = "";
  const newLuBill = await patientapi.updateLuBillAdditionalInfo(luBillId, additionalInfoCode);
  currLuBill.value = newLuBill;
}

async function addLuActBackend(luActCode: string) {
  const entryId = currentEntryStore.currentEntryId;
  const luBillId = currLuBill.value.luBillId;
  const prevIds = new Set(
    currLuBill.value.luBilledActs?.map(act => act.luBilledActId) ?? []
  );
  const newLuBill = await patientapi.addLuActToLuBill(luBillId, luActCode, entryId);
  currLuBill.value = newLuBill;
  const luBilledAct = newLuBill.luBilledActs?.find(
    act => !prevIds.has(act.luBilledActId) && act.code === luActCode
  );
  if (!luBilledAct) return;
  if (luBilledAct.isFirstHospiDay) {
    clearAct();
    newHospiAct.value = luBilledAct;
    nextTick(() => {
      dropd.value = 'DateLocation' + luBilledAct.luBilledActId;
    })
  } else if (luBilledAct.isSurgeryAct) {
    clearAct();
    editedAct.value = luBilledAct;
    nextTick(() => {
      dropd.value = 'DateLocation' + luBilledAct.luBilledActId;
    })
  }
}

function addLuAct(act){
  const luActCode = act.code
  searchInputRef.value.hideDropdown()
  searchInput.value = ""
  addLuActBackend(luActCode);
}

async function addLuCustomAct(act: any){
  const appUserLuActId = act.appUserLuActId;
  const luBillId = currLuBill.value.luBillId
  const entryId = currentEntryStore.currentEntryId;
  const newLuBill = await patientapi.addAppUserLuActToLuBill(luBillId, appUserLuActId, entryId);
  currLuBill.value = newLuBill;
}

async function afterChangedCustomActs() {
  dropd.value = "";
  await appUserStore.setCurrentAppUserData();
}

async function updatePrefix(act, prefix: string | null) {
  const luBilledActId = act.luBilledActId
  const newLuBill = await patientapi.updatePrefix(luBilledActId, prefix)
  currLuBill.value = newLuBill
  dropd.value = ""
}

async function updateSuffix(act, modification) {
  const luBilledActId = act.luBilledActId
  const suffix = modification.suffix
  const newLuBill = await patientapi.updateSuffix(luBilledActId, suffix)
  currLuBill.value = newLuBill
  dropd.value = ""
}

async function addSurgeryAssistance(act, pwrHealthPro) {
  const misaNumber = pwrHealthPro.misaNumber
  const luBilledActId = act.luBilledActId
  dropd2.value = ""
  dropd.value = ""  
  const newLuBill = await patientapi.addSurgeryAssistance(luBilledActId, misaNumber)
  currLuBill.value = newLuBill
} 

async function updateMisaNumber(act, pwrHealthPro) {
  const misaNumber = pwrHealthPro.misaNumber
  const luBilledActId = act.luBilledActId
  dropd2.value = ""
  const newLuBill = await patientapi.updateMisaNumber(luBilledActId, misaNumber)
  currLuBill.value = newLuBill
}

async function updateActDate(newDate: Date) {
  hospiStartDate.value = newDate;
  await updateActDateInBackend(editedAct.value);
}

async function updateActNumberMultiplier(act) {
  const luBilledActId = act.luBilledActId
  const numberMultiplier = act.actNumberMultiplier
  const newLuBill = await patientapi.updateNumberMultiplier(luBilledActId, numberMultiplier)
  currLuBill.value = newLuBill
}

function getMainLocation(code) {
  if (!code) return null;
  if (!interopLuStore.interopLuData) return null;
  return interopLuStore.interopLuData.luLocationMainCode.find(mainLocation => mainLocation.code === code);
}

function getSubLocation(code) {
  if (!code) return null;
  if (!interopLuStore.interopLuData) return null;
  return interopLuStore.interopLuData.luLocationSubCode.find(subLocation => subLocation.code === code);
}

function isHospitalLocation(code) {
  const mainLocation = getMainLocation(code);
  if (!mainLocation) return false;
  return mainLocation.luLocationMainType !== 'ExtraHospital'
}


function getAdditionalInfo(code) {
  if (!code) return null;
  if (!interopLuStore.interopLuData) return null;
  return interopLuStore.interopLuData.luBillAdditionalInfo.find(additionalInfo => additionalInfo.code === code);
}

function getAdditionalInfoText(code) {
  const additionalInfo = getAdditionalInfo(code);
  if (!additionalInfo) return "+";
  return additionalInfo.code + " - " + additionalInfo.description
}

function getMainLocationText(code) {
  const mainLocation = getMainLocation(code);
  if (!mainLocation) return "";
  return mainLocation.code + " - " + mainLocation.description
}

function geSubLocationText(code) {
  const subLocation = getSubLocation(code);
  if (!subLocation) return "";
  return subLocation.code + " - " + subLocation.description
}

function getFullLocation(act) {
  return isHospitalLocation(act.mainLocation)
    ? act.mainLocation + act.subLocation
    : act.mainLocation
}

async function setMainCode(act, luLocationMainCode) {
  const luBilledActId = act.luBilledActId
  const newCode = luLocationMainCode.code
  dropd2.value = ""
  act.mainLocation = newCode
  const newLuBill = await patientapi.updateLuLocationMainCode(luBilledActId, newCode)
  currLuBill.value = newLuBill
}

async function setSubCode(act, luLocationSubCode) {
  const luBilledActId = act.luBilledActId
  const newCode = luLocationSubCode.code
  dropd2.value = ""
  act.subLocation = newCode
  const newLuBill = await patientapi.updateLuLocationSubCode(luBilledActId, newCode)
  currLuBill.value = newLuBill
}

async function setLuActClass(act: any, luActClass: string) {
  const luBilledActId = act.luBilledActId;
  hasClassChanged.value = true;
  act.actClass = luActClass;
  const newLuBill = await patientapi.updateLuActClass(luBilledActId, luActClass);
  currLuBill.value = newLuBill;
}

async function updateFee(act) {
  const luBilledActId = act.luBilledActId
  const fee = act.fee
  const newLuBill = await patientapi.updateFee(luBilledActId, fee)
  currLuBill.value = newLuBill
}

async function deleteSingleLuAct(act){
  const luBilledActId = act.luBilledActId
  const newLuBill = await patientapi.deleteLuBilledAct(luBilledActId)
  currLuBill.value = newLuBill
}

function createSuffixList() {
  if (!interopLuStore.interopLuData) suffixList.value = []
  let {luActModifications} = interopLuStore.interopLuData
  luActModifications = gen.deepCopy(luActModifications)
  const nullModification = {
    suffix: "",
    multiplier: "1",
    shortDescription: "Aucun",
  }
  luActModifications.unshift(nullModification)
  suffixList.value = luActModifications
}

const allActesValues = computed(() => {
  if (!interopLuStore.interopLuData) return []
  return interopLuStore.interopLuData.luActs
    .map(luAct => {
      let copiedLuAct = gen.deepCopy(luAct)
      copiedLuAct.searchTerm = (copiedLuAct.code + " " + copiedLuAct.description).toUpperCase()
      return copiedLuAct
    })
})

const favorites = computed(() => {
  if (!appUserStore.currentAppUserData) return null
  return appUserStore.currentAppUserData.preferences.luActsParsedFavorites
})

const customActs = computed(() => {
  if (!appUserStore.currentAppUserData) return null
  return appUserStore.currentAppUserData.preferences.luActsCustom
})

function isFavoriteAct(currAct) {
  return Object.values(favorites.value).some(typeGroup =>
    typeGroup.some(act => act.code === currAct.code)
  )
}

const isTemplateStatus = computed(() => {
  return currPatientDoc.value.templateStatus === 'Template'
})

async function setBillingFromRefSheets() {
  const existingActs = currLuBill.value.luBilledActs.length;
  if (existingActs > 0) return;
  const codes = [...new Set(
    currentEntryStore.currCclSuggestionsFromResults.expressions
      .map(expr => expr.refSheet?.billing)
      .filter(billing => billing != null)
      .flat()
  )];
  for (const code of codes) {
    await addLuActBackend(code);
  }
}

function setCurrentEditAct(act) {
  clearAct();
  editedAct.value = act;
}

async function updateActDateInBackend(act) {
  if (!act || !hospiStartDate.value) return;
  currLuBill.value = await patientapi.updateActDate(
    act.luBilledActId,
    format(hospiStartDate.value, DateFormat.ISO_SMALL)  //Conversion to avoid unwanted TZ change
  );  
}

const isSingleDayHospi = computed(() =>
  !!hospiStartDate.value && (!hospiEndDate.value || isSameDay(hospiStartDate.value, hospiEndDate.value))
)

async function addLuActsToLuBillUntilEndDate() {
  if (!newHospiAct.value || !hospiStartDate.value || !hospiEndDate.value) return;
  currLuBill.value = await patientapi.addLuActsToLuBillUntilEndDate(
    newHospiAct.value.luBilledActId,
    format(hospiStartDate.value, DateFormat.ISO_SMALL),
    format(hospiEndDate.value, DateFormat.ISO_SMALL)
  );
}

async function updateAllFollowingLuActsToNewClass(act: any) {
  const luBilledActId = act.luBilledActId;
  const newLuBill = await patientapi.updateAllFollowingLuActsToNewClass(luBilledActId);
  currLuBill.value = newLuBill;
  dropd.value = "";
}

async function separateCombinedAct(act: any) {
  const luBilledActId = act.luBilledActId;
  const newLuBill = await patientapi.separateCombinedAct(luBilledActId);
  currLuBill.value = newLuBill;
  dropd.value = "";
}


async function initialize() {
  if (!interopLuStore.interopLuData) {
    await interopLuStore.setInteropLuData()
  }
  createSuffixList()
  setBillingFromRefSheets()
  getStudentsByInstitute()
}

const hasClassChanged = ref(false);

async function onActPopupClose() {
  if (newHospiAct.value) {
    if (isSingleDayHospi.value) {
      await updateActDateInBackend(newHospiAct.value);
    } else if (hospiStartDate.value && hospiEndDate.value) {
      await addLuActsToLuBillUntilEndDate();
    }
  }
  clearAct();
}

function clearAct() {
  newHospiAct.value = null;
  editedAct.value = null;
  hospiStartDate.value = null;
  hospiEndDate.value = null;
  hasClassChanged.value = false;
}

watch(currFinancialGroup, (newGroup) => {
  if (newGroup) {
    getHealthProsByFinancialGroup();
  }
}, { immediate: true });

onMounted(() => {
  initialize()
})


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_listGroup = _resolveComponent("listGroup")!
  const _component_inputComboBox2 = _resolveComponent("inputComboBox2")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!
  const _component_list_group = _resolveComponent("list-group")!
  const _component_dbGroup = _resolveComponent("dbGroup")!
  const _component_item_scroll = _resolveComponent("item-scroll")!
  const _component_switchGroup = _resolveComponent("switchGroup")!
  const _component_esInputDateTime = _resolveComponent("esInputDateTime")!
  const _component_inputLineNew2 = _resolveComponent("inputLineNew2")!
  const _component_inputBox = _resolveComponent("inputBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(interopLuStore).interopLuData)
      ? (_openBlock(), _createBlock(_component_text_item, {
          key: 0,
          txt: _unref(t)('common.loading'),
          styles: "font-mBold"
        }, null, 8, ["txt"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (isTemplateStatus.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_inputComboBox2, {
                  ref_key: "searchInputRef",
                  ref: searchInputRef,
                  modelValue: searchInput.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchInput).value = $event)),
                  placeholder: _unref(t)('patient.document.luBillAddon.codeOrAct'),
                  style: {"width":"27rem"}
                }, {
                  dropd: _withCtx(() => [
                    (filteredActs.value.length > 0)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(filteredActs.value, (luAct, index) => {
                          return (_openBlock(), _createBlock(_component_listGroup, {
                            key: index,
                            styles: "pad-s",
                            onClick: ($event: any) => (addLuAct(luAct))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_3, [
                                _createVNode(_component_text_item, {
                                  class: "mleft-06",
                                  style: {"min-width":"3rem"},
                                  txt: luAct.code
                                }, null, 8, ["txt"]),
                                _createVNode(_component_text_item, {
                                  class: "mleft-06 linebreak",
                                  txt: luAct.description,
                                  styles: "main-m"
                                }, null, 8, ["txt"])
                              ])
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        }), 128))
                      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createVNode(_component_text_item, {
                            class: "mleft-04",
                            txt: _unref(t)('patient.document.luBillAddon.codeOrAct'),
                            styles: "main-l"
                          }, null, 8, ["txt"])
                        ]))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"]),
                _createVNode(_component_dropdownBox, {
                  modelValue: dropd.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dropd).value = $event)),
                  openOn: "Settings"
                }, {
                  dropd: _withCtx(() => [
                    _createVNode(editAppUserPreferences, {
                      title: "Actes favoris",
                      referenceTextType: "LuActs",
                      dtoKey: "luActsFavorites"
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_buttonGroup, { class: "mleft-02 mtop-02" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_svg_item, {
                          icon: "settings",
                          styles: "size-m main-l"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          (isTemplateStatus.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (favorites.value?.ActeGénéral?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.document.luBillAddon.generalActs'),
                        styles: "font-mBold"
                      }, null, 8, ["txt"]),
                      _createVNode(_component_dbGroup, { class: "mtop-02" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(favorites.value.ActeGénéral, (item, index) => {
                            return (_openBlock(), _createBlock(_component_list_group, {
                              key: index,
                              styles: "pad-0",
                              onClick: ($event: any) => (addLuAct(item))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_text_item, {
                                  txt: item.code
                                }, null, 8, ["txt"]),
                                _createVNode(_component_text_item, {
                                  txt: item.description,
                                  class: "mleft-04"
                                }, null, 8, ["txt"])
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (favorites.value?.ActeTechnique?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.document.luBillAddon.technicalActs'),
                        styles: "font-mBold"
                      }, null, 8, ["txt"]),
                      _createVNode(_component_dbGroup, { class: "mtop-02" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(favorites.value.ActeTechnique, (item, index) => {
                            return (_openBlock(), _createBlock(_component_list_group, {
                              key: index,
                              styles: "pad-0",
                              onClick: ($event: any) => (addLuAct(item))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_text_item, {
                                  txt: item.code
                                }, null, 8, ["txt"]),
                                _createVNode(_component_text_item, {
                                  txt: item.description,
                                  class: "mleft-04"
                                }, null, 8, ["txt"])
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (favorites.value?.ActeLabo?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.document.luBillAddon.labActs'),
                        styles: "font-mBold"
                      }, null, 8, ["txt"]),
                      _createVNode(_component_dbGroup, { class: "mtop-02" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(favorites.value.ActeLabo, (item, index) => {
                            return (_openBlock(), _createBlock(_component_list_group, {
                              key: index,
                              styles: "pad-0",
                              onClick: ($event: any) => (addLuAct(item))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_text_item, {
                                  txt: item.code
                                }, null, 8, ["txt"]),
                                _createVNode(_component_text_item, {
                                  txt: item.description,
                                  class: "mleft-04"
                                }, null, 8, ["txt"])
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (favorites.value?.ActeCp?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_text_item, {
                        txt: "CP",
                        styles: "font-mBold"
                      }),
                      _createVNode(_component_dbGroup, { class: "mtop-02" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(favorites.value.ActeCp, (item, index) => {
                            return (_openBlock(), _createBlock(_component_list_group, {
                              key: index,
                              styles: "pad-0",
                              onClick: ($event: any) => (addLuAct(item))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_text_item, {
                                  txt: item.code
                                }, null, 8, ["txt"]),
                                _createVNode(_component_text_item, {
                                  txt: item.description,
                                  class: "mleft-04"
                                }, null, 8, ["txt"])
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (favorites.value?.ActeAmmd?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_text_item, {
                        txt: "AMMD",
                        styles: "font-mBold"
                      }),
                      _createVNode(_component_dbGroup, { class: "mtop-02" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(favorites.value.ActeAmmd, (item, index) => {
                            return (_openBlock(), _createBlock(_component_list_group, {
                              key: index,
                              styles: "pad-0",
                              onClick: ($event: any) => (addLuAct(item))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_text_item, {
                                  txt: item.code
                                }, null, 8, ["txt"]),
                                _createVNode(_component_text_item, {
                                  txt: item.description,
                                  class: "mleft-04"
                                }, null, 8, ["txt"])
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_text_item, {
                      txt: _unref(t)('patient.document.luBillAddon.personalActs'),
                      styles: "font-mBold"
                    }, null, 8, ["txt"]),
                    _createVNode(_component_dropdownBox, {
                      modelValue: dropd.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dropd).value = $event)),
                      openOn: "CustomActEdit"
                    }, {
                      dropd: _withCtx(() => [
                        _createVNode(docLuBillCustomActsSettings, {
                          onClose: _cache[2] || (_cache[2] = ($event: any) => (afterChangedCustomActs()))
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_buttonGroup, { class: "mleft-02" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_svg_item, {
                              icon: "settings",
                              styles: "main-l"
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createVNode(_component_dbGroup, { class: "mtop-02" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customActs.value, (item, index) => {
                        return (_openBlock(), _createBlock(_component_list_group, {
                          key: index,
                          styles: "pad-0",
                          onClick: ($event: any) => (addLuCustomAct(item))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: item.description
                            }, null, 8, ["txt"])
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (isTemplateStatus.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createVNode(_component_text_item, {
              txt: _unref(t)('patient.document.luBillAddon.acts'),
              class: "mtop-20",
              styles: "font-mBold"
            }, null, 8, ["txt"]),
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currLuBill.value.luBilledActs, (act, actIndex) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: act.luBilledActId
                }, [
                  _createElementVNode("div", {
                    style: _normalizeStyle('grid-row:' + (actIndex + 2) + '; grid-column: 1 / trash'),
                    class: "bg-card"
                  }, null, 4),
                  _createElementVNode("div", {
                    style: _normalizeStyle('grid-area:' + (actIndex + 2) + '/ date;'),
                    class: "colend w-full"
                  }, [
                    (isTemplateStatus.value)
                      ? (_openBlock(), _createBlock(_component_dropdownBox, {
                          key: 0,
                          modelValue: dropd.value,
                          "onUpdate:modelValue": [
                            _cache[10] || (_cache[10] = ($event: any) => ((dropd).value = $event)),
                            _cache[11] || (_cache[11] = newDropd => newDropd === '' && onActPopupClose())
                          ],
                          openOn: 'DateLocation' + act.luBilledActId
                        }, {
                          dropd: _withCtx(() => [
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("div", _hoisted_18, [
                                (newHospiAct.value)
                                  ? (_openBlock(), _createBlock(_component_text_item, {
                                      key: 0,
                                      txt: _unref(t)('patient.document.luBillAddon.hospitalisation'),
                                      styles: "font-l"
                                    }, null, 8, ["txt"]))
                                  : (_openBlock(), _createBlock(_component_text_item, {
                                      key: 1,
                                      txt: _unref(apiDateString)(act.actDate),
                                      styles: "font-l"
                                    }, null, 8, ["txt"])),
                                _createVNode(_component_text_item, {
                                  txt: "-",
                                  styles: "font-l"
                                }),
                                _createVNode(_component_text_item, {
                                  txt: act.code,
                                  styles: "font-l"
                                }, null, 8, ["txt"])
                              ]),
                              _createElementVNode("div", _hoisted_19, [
                                _createVNode(_component_text_item, {
                                  style: {"grid-column":"left"},
                                  txt: _unref(t)('patient.document.luBillAddon.executor'),
                                  styles: "main-m",
                                  class: "mtop-04 align-r"
                                }, null, 8, ["txt"]),
                                _createElementVNode("div", _hoisted_20, [
                                  _createVNode(_component_dropdownBox, {
                                    modelValue: dropd2.value,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dropd2).value = $event)),
                                    openOn: "Executor",
                                    class: "w-maxC"
                                  }, {
                                    dropd: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_21, [
                                        _createVNode(_component_dbGroup, null, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allHealthProsAndStudents.value, (pwrHealthPro, index) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: index,
                                                class: "row"
                                              }, [
                                                _createVNode(_component_list_group, {
                                                  styles: "pad-s",
                                                  class: "gap-04 w-full",
                                                  onClick: ($event: any) => (updateMisaNumber(act, pwrHealthPro))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_text_item, {
                                                      txt: pwrHealthPro.lastName
                                                    }, null, 8, ["txt"]),
                                                    _createVNode(_component_text_item, {
                                                      txt: pwrHealthPro.firstName
                                                    }, null, 8, ["txt"])
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"])
                                              ]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ])
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_buttonGroup, {
                                        styles: "bg-white border-vl",
                                        class: "row gap-04 psides-10"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_text_item, {
                                            txt: getHealthProName(act),
                                            class: "btn-text-dimensions"
                                          }, null, 8, ["txt"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue"]),
                                  (act.isSurgeryAct)
                                    ? (_openBlock(), _createBlock(_component_dropdownBox, {
                                        key: 0,
                                        modelValue: dropd2.value,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dropd2).value = $event)),
                                        openOn: 'ExecutorCopy' + act.luBilledActId
                                      }, {
                                        dropd: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_22, [
                                            _createVNode(_component_dbGroup, null, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allHealthProsAndStudents.value, (pwrHealthPro, index) => {
                                                  return (_openBlock(), _createBlock(_component_list_group, {
                                                    key: index,
                                                    styles: "pad-s",
                                                    class: "gap-04 w-full",
                                                    onClick: ($event: any) => (addSurgeryAssistance(act, pwrHealthPro))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_text_item, {
                                                        txt: pwrHealthPro.lastName
                                                      }, null, 8, ["txt"]),
                                                      _createVNode(_component_text_item, {
                                                        txt: pwrHealthPro.firstName
                                                      }, null, 8, ["txt"])
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ])
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_buttonGroup, {
                                            styles: "border-l",
                                            class: "mleft-10 btn-pad"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_svg_item, {
                                                icon: "plus",
                                                styles: "main-m",
                                                class: "mtop-01"
                                              }),
                                              _createVNode(_component_text_item, {
                                                txt: _unref(t)('patient.document.luBillAddon.surgeryAssistance'),
                                                styles: "main-m",
                                                class: "mleft-02"
                                              }, null, 8, ["txt"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "openOn"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode(_component_text_item, {
                                  style: {"grid-column":"left"},
                                  txt: _unref(t)('patient.document.luBilledAct.mainLocation'),
                                  styles: "main-m",
                                  class: "mtop-04 align-r"
                                }, null, 8, ["txt"]),
                                _createElementVNode("div", _hoisted_23, [
                                  _createVNode(_component_dropdownBox, {
                                    modelValue: dropd2.value,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dropd2).value = $event)),
                                    openOn: "mainLocation",
                                    class: "w-maxC"
                                  }, {
                                    dropd: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_24, [
                                        _createVNode(_component_item_scroll, { class: "h-full" }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(interopLuStore).interopLuData.luLocationMainCode, (luLocationMainCode, index) => {
                                              return (_openBlock(), _createBlock(_component_list_group, {
                                                key: index,
                                                styles: "pad-s",
                                                onClick: ($event: any) => (setMainCode(act, luLocationMainCode))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_text_item, {
                                                    txt: luLocationMainCode.code,
                                                    class: "mleft-06"
                                                  }, null, 8, ["txt"]),
                                                  _createVNode(_component_text_item, {
                                                    txt: luLocationMainCode.description,
                                                    styles: "main-m",
                                                    class: "mleft-08 btn-text-dimensions"
                                                  }, null, 8, ["txt"])
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ])
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_buttonGroup, {
                                        styles: "bg-white border-vl",
                                        class: "psides-10"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_text_item, {
                                            txt: getMainLocationText(act.mainLocation),
                                            class: "btn-text-dimensions"
                                          }, null, 8, ["txt"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue"])
                                ]),
                                (isHospitalLocation(act.mainLocation))
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createVNode(_component_text_item, {
                                        style: {"grid-column":"left"},
                                        txt: _unref(t)('patient.document.luBilledAct.subLocation'),
                                        styles: "main-m",
                                        class: "mtop-04 align-r"
                                      }, null, 8, ["txt"]),
                                      _createElementVNode("div", _hoisted_25, [
                                        _createVNode(_component_dropdownBox, {
                                          modelValue: dropd2.value,
                                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((dropd2).value = $event)),
                                          openOn: "subLocation",
                                          class: "w-maxC"
                                        }, {
                                          dropd: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_26, [
                                              _createVNode(_component_item_scroll, { class: "h-full" }, {
                                                default: _withCtx(() => [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(interopLuStore).interopLuData.luLocationSubCode, (luLocationSubCode, index) => {
                                                    return (_openBlock(), _createBlock(_component_list_group, {
                                                      key: index,
                                                      styles: "pad-s",
                                                      onClick: ($event: any) => (setSubCode(act, luLocationSubCode))
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_text_item, {
                                                          txt: luLocationSubCode.code,
                                                          class: "mleft-06"
                                                        }, null, 8, ["txt"]),
                                                        _createVNode(_component_text_item, {
                                                          txt: luLocationSubCode.description,
                                                          styles: "main-m",
                                                          class: "mleft-08 btn-text-dimensions"
                                                        }, null, 8, ["txt"])
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["onClick"]))
                                                  }), 128))
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ])
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_buttonGroup, {
                                              styles: "bg-white border-vl",
                                              class: "psides-10"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_text_item, {
                                                  txt: geSubLocationText(act.subLocation) || '\u00A0',
                                                  class: "btn-text-dimensions"
                                                }, null, 8, ["txt"])
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue"])
                                      ])
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (['ActeGénéral', 'ActeTechnique'].includes(act.luActType))
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createVNode(_component_text_item, {
                                        style: {"grid-column":"left"},
                                        txt: "Classe",
                                        styles: "main-m",
                                        class: "mtop-04 align-r"
                                      }),
                                      _createElementVNode("div", _hoisted_27, [
                                        _createVNode(_component_switchGroup, {
                                          styles: "padButton-s",
                                          class: "psides-10",
                                          active: act.actClass === '1',
                                          onClick: ($event: any) => (setLuActClass(act, '1'))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_text_item, {
                                              txt: "1",
                                              class: _normalizeClass(act.actClass === '1' ? 'txt-white' : '')
                                            }, null, 8, ["class"])
                                          ]),
                                          _: 2
                                        }, 1032, ["active", "onClick"]),
                                        _createVNode(_component_switchGroup, {
                                          styles: "padButton-s",
                                          class: "psides-10",
                                          active: act.actClass === '2',
                                          onClick: ($event: any) => (setLuActClass(act, '2'))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_text_item, {
                                              txt: "2",
                                              class: _normalizeClass(act.actClass === '2' ? 'txt-white' : '')
                                            }, null, 8, ["class"])
                                          ]),
                                          _: 2
                                        }, 1032, ["active", "onClick"]),
                                        (!act.isHospiCode)
                                          ? (_openBlock(), _createBlock(_component_switchGroup, {
                                              key: 0,
                                              styles: "padButton-s",
                                              class: "psides-10",
                                              active: act.actClass === '',
                                              onClick: ($event: any) => (setLuActClass(act, ''))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_text_item, {
                                                  txt: "∅",
                                                  class: _normalizeClass(act.actClass === '' ? 'txt-white' : '')
                                                }, null, 8, ["class"])
                                              ]),
                                              _: 2
                                            }, 1032, ["active", "onClick"]))
                                          : _createCommentVNode("", true),
                                        (hasClassChanged.value && !newHospiAct.value)
                                          ? (_openBlock(), _createBlock(_component_buttonGroup, {
                                              key: 1,
                                              class: "mleft-10 psides-06",
                                              styles: "border-l pad-s",
                                              onClick: ($event: any) => (updateAllFollowingLuActsToNewClass(act))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_text_item, {
                                                  txt: _unref(t)('patient.document.luBilledAct.applyHospiClassToNextActs', { actClass: act.actClass || '∅'}),
                                                  styles: "main-m"
                                                }, null, 8, ["txt"])
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (newHospiAct.value)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                      _createVNode(_component_text_item, {
                                        style: {"grid-column":"left"},
                                        txt: "Dates d'hospit.",
                                        styles: "main-m",
                                        class: "align-r mtop-04"
                                      }),
                                      _createElementVNode("div", _hoisted_28, [
                                        _createElementVNode("div", _hoisted_29, [
                                          _createVNode(_component_esInputDateTime, {
                                            inline: "",
                                            dateTimeValue: hospiStartDate.value ? [hospiStartDate.value, hospiEndDate.value] : null,
                                            dateFormat: _unref(DateFormat).DATEPICKER,
                                            range: true,
                                            withTime: false,
                                            onUpdateDateTime: _cache[8] || (_cache[8] = ($event: any) => (changeHospiDate($event)))
                                          }, null, 8, ["dateTimeValue", "dateFormat"])
                                        ])
                                      ])
                                    ], 64))
                                  : (act.isHospiCode || act.actDate !== act.actDateUntil)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                        _createVNode(_component_text_item, {
                                          style: {"grid-column":"left"},
                                          txt: "Date(s)",
                                          styles: "main-m",
                                          class: "align-r mtop-04"
                                        }),
                                        _createElementVNode("div", _hoisted_30, [
                                          _createVNode(_component_text_item, {
                                            txt: _unref(apiDateString)(act.actDate)
                                          }, null, 8, ["txt"]),
                                          (act.actDate !== act.actDateUntil)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createVNode(_component_text_item, { txt: "-" }),
                                                _createVNode(_component_text_item, {
                                                  txt: _unref(apiDateString)(act.actDateUntil)
                                                }, null, 8, ["txt"]),
                                                (act.actDate !== act.actDateUntil)
                                                  ? (_openBlock(), _createBlock(_component_buttonGroup, {
                                                      key: 0,
                                                      styles: "border-l pad-s",
                                                      class: "psides-10 mleft-10",
                                                      onClick: ($event: any) => (separateCombinedAct(act))
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_text_item, {
                                                          txt: _unref(t)('patient.document.luBillAddon.separateDates'),
                                                          styles: "font-mBold",
                                                          class: "btn-text-dimensions"
                                                        }, null, 8, ["txt"])
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["onClick"]))
                                                  : _createCommentVNode("", true)
                                              ], 64))
                                            : _createCommentVNode("", true)
                                        ])
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                        _createVNode(_component_text_item, {
                                          style: {"grid-column":"left"},
                                          txt: _unref(t)('patient.document.luBilledAct.date'),
                                          styles: "main-m",
                                          class: "align-r mtop-04"
                                        }, null, 8, ["txt"]),
                                        _createElementVNode("div", _hoisted_31, [
                                          _createElementVNode("div", _hoisted_32, [
                                            _createVNode(_component_esInputDateTime, {
                                              inline: "",
                                              dateTimeValue: hospiStartDate.value ?? new Date(act.actDate),
                                              dateFormat: _unref(DateFormat).DATEPICKER,
                                              range: false,
                                              withTime: false,
                                              onUpdateDateTime: _cache[9] || (_cache[9] = ($event: any) => (updateActDate($event)))
                                            }, null, 8, ["dateTimeValue", "dateFormat"])
                                          ])
                                        ])
                                      ], 64))
                              ])
                            ])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_buttonGroup, {
                              onClick: ($event: any) => (setCurrentEditAct(act))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_14, [
                                  _createVNode(_component_text_item, {
                                    txt: _unref(apiDateString)(act.actDate)
                                  }, null, 8, ["txt"]),
                                  _createElementVNode("div", _hoisted_15, [
                                    _createVNode(_component_text_item, {
                                      txt: getHealthProShortName(act),
                                      class: "mleft-auto",
                                      styles: "font-s"
                                    }, null, 8, ["txt"])
                                  ]),
                                  _createElementVNode("div", _hoisted_16, [
                                    _createVNode(_component_text_item, {
                                      txt: getFullLocation(act),
                                      styles: "font-s main-m",
                                      class: "mleft-auto"
                                    }, null, 8, ["txt"]),
                                    _createVNode(_component_text_item, {
                                      txt: act.actClass ? act.actClass + '.' : '',
                                      styles: "font-s main-m",
                                      class: "mleft-06"
                                    }, null, 8, ["txt"])
                                  ])
                                ])
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "openOn"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _createVNode(_component_text_item, {
                            txt: _unref(apiDateString)(act.actDate)
                          }, null, 8, ["txt"]),
                          _createVNode(_component_text_item, {
                            txt: getFullLocation(act),
                            styles: "font-s main-m",
                            class: "mleft-01"
                          }, null, 8, ["txt"])
                        ]))
                  ], 4),
                  _createElementVNode("div", {
                    style: _normalizeStyle('grid-area:' + (actIndex + 2) + '/ acte;'),
                    class: "row-top"
                  }, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          (act.actDateUntil && (act.actDate !== act.actDateUntil))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createVNode(_component_text_item, {
                                  txt: _unref(t)('common.until').toLowerCase(),
                                  styles: "font-s"
                                }, null, 8, ["txt"]),
                                _createVNode(_component_text_item, {
                                  txt: _unref(apiDateString)(act.actDateUntil),
                                  class: "mleft-04"
                                }, null, 8, ["txt"]),
                                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "mleft-04" }, null, -1))
                              ], 64))
                            : _createCommentVNode("", true),
                          (act.code)
                            ? (_openBlock(), _createBlock(_component_text_item, {
                                key: 1,
                                txt: act.code,
                                styles: "font-mBold",
                                class: "cursor-sel"
                              }, null, 8, ["txt"]))
                            : (_openBlock(), _createBlock(_component_text_item, {
                                key: 2,
                                txt: act.description,
                                styles: "font-mBold",
                                class: "cursor-sel"
                              }, null, 8, ["txt"])),
                          (act.isPrefixAct)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                (isTemplateStatus.value)
                                  ? (_openBlock(), _createBlock(_component_dropdownBox, {
                                      key: 0,
                                      modelValue: dropd.value,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((dropd).value = $event)),
                                      openOn: 'Prefix' + act.luBilledActId
                                    }, {
                                      dropd: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_37, [
                                          _createVNode(_component_dbGroup, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_list_group, {
                                                styles: "pad-s",
                                                class: "gap-02",
                                                onClick: ($event: any) => (updatePrefix(act, null))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_text_item, {
                                                    txt: _unref(t)('patient.document.luBillAddon.removePrefix')
                                                  }, null, 8, ["txt"])
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]),
                                              _createVNode(_component_list_group, {
                                                styles: "pad-s",
                                                class: "gap-02",
                                                onClick: ($event: any) => (updatePrefix(act, 'OD'))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_text_item, { txt: "OD" }),
                                                  _createVNode(_component_text_item, { txt: "-" }),
                                                  _createVNode(_component_text_item, {
                                                    txt: _unref(t)('patient.ophtalmo.rightEye')
                                                  }, null, 8, ["txt"])
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]),
                                              _createVNode(_component_list_group, {
                                                styles: "pad-s",
                                                class: "gap-02",
                                                onClick: ($event: any) => (updatePrefix(act, 'OG'))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_text_item, { txt: "OG" }),
                                                  _createVNode(_component_text_item, { txt: "-" }),
                                                  _createVNode(_component_text_item, {
                                                    txt: _unref(t)('patient.ophtalmo.leftEye')
                                                  }, null, 8, ["txt"])
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ])
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_buttonGroup, {
                                          styles: "border-vl pad-s",
                                          class: "psides-04"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_text_item, {
                                              txt: act.actModificationPrefix || _unref(t)('patient.document.luBillAddon.prefix')
                                            }, null, 8, ["txt"]),
                                            (!act.actModificationPrefix)
                                              ? (_openBlock(), _createBlock(_component_svg_item, {
                                                  key: 0,
                                                  icon: "plus",
                                                  styles: "main-m",
                                                  class: "mleft-02 mtop-01"
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "openOn"]))
                                  : (act.actModificationPrefix)
                                    ? (_openBlock(), _createBlock(_component_text_item, {
                                        key: 1,
                                        txt: act.actModificationPrefix,
                                        styles: "font-mBold",
                                        class: "mright-06"
                                      }, null, 8, ["txt"]))
                                    : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true),
                          (act.isSuffixAct)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                (isTemplateStatus.value)
                                  ? (_openBlock(), _createBlock(_component_dropdownBox, {
                                      key: 0,
                                      modelValue: dropd.value,
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((dropd).value = $event)),
                                      openOn: 'Suffix' + act.luBilledActId
                                    }, {
                                      dropd: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_38, [
                                          (act.isSuffixAct)
                                            ? (_openBlock(), _createBlock(_component_dbGroup, { key: 0 }, {
                                                default: _withCtx(() => [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suffixList.value, (modification, index) => {
                                                    return (_openBlock(), _createBlock(_component_list_group, {
                                                      key: index,
                                                      styles: "pad-s",
                                                      class: "gap-02",
                                                      onClick: ($event: any) => (updateSuffix(act, modification))
                                                    }, {
                                                      default: _withCtx(() => [
                                                        (modification.suffix)
                                                          ? (_openBlock(), _createBlock(_component_text_item, {
                                                              key: 0,
                                                              txt: modification.suffix
                                                            }, null, 8, ["txt"]))
                                                          : _createCommentVNode("", true),
                                                        (modification.suffix)
                                                          ? (_openBlock(), _createBlock(_component_text_item, {
                                                              key: 1,
                                                              txt: "-"
                                                            }))
                                                          : _createCommentVNode("", true),
                                                        _createVNode(_component_text_item, {
                                                          txt: modification.shortDescription
                                                        }, null, 8, ["txt"]),
                                                        _createVNode(_component_text_item, {
                                                          txt: '(x' + modification.multiplier + ')',
                                                          class: "mleft-04"
                                                        }, null, 8, ["txt"])
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["onClick"]))
                                                  }), 128))
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_buttonGroup, {
                                          styles: "border-vl pad-s",
                                          class: "psides-04"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_text_item, {
                                              txt: act.actModificationSuffix || _unref(t)('patient.document.luBillAddon.suffix')
                                            }, null, 8, ["txt"]),
                                            (!act.actModificationSuffix)
                                              ? (_openBlock(), _createBlock(_component_svg_item, {
                                                  key: 0,
                                                  icon: "plus",
                                                  styles: "main-m",
                                                  class: "mleft-02 mtop-01"
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "openOn"]))
                                  : (act.actModificationSuffix)
                                    ? (_openBlock(), _createBlock(_component_text_item, {
                                        key: 1,
                                        txt: act.actModificationSuffix,
                                        styles: "font-mBold",
                                        class: "mleft-06"
                                      }, null, 8, ["txt"]))
                                    : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true),
                          (act.isMultiplicationAct || act.actNumberMultiplier > 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                _createVNode(_component_text_item, { txt: "x" }),
                                (isTemplateStatus.value && act.isMultiplicationAct)
                                  ? (_openBlock(), _createBlock(_component_inputBox, {
                                      key: 0,
                                      style: {"width":"3rem"},
                                      class: "mleft-04"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_inputLineNew2, {
                                          modelValue: act.actNumberMultiplier,
                                          "onUpdate:modelValue": ($event: any) => ((act.actNumberMultiplier) = $event),
                                          onKeydown: _unref(gen).onlyInteger,
                                          onBlur: ($event: any) => (updateActNumberMultiplier(act))
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown", "onBlur"])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : (_openBlock(), _createBlock(_component_text_item, {
                                      key: 1,
                                      txt: act.actNumberMultiplier
                                    }, null, 8, ["txt"]))
                              ]))
                            : _createCommentVNode("", true),
                          (isTemplateStatus.value && act.code && !act.isCodeExtension && favorites.value && !isFavoriteAct(act) && !isInpatientDayExceptFirst(act) && act.actNumberMultiplier <= 1)
                            ? (_openBlock(), _createBlock(_component_dropdownBox, {
                                key: 6,
                                modelValue: dropd.value,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((dropd).value = $event)),
                                openOn: 'NewFavorite' + act.luBilledActId
                              }, {
                                dropd: _withCtx(() => [
                                  _createVNode(docLuBillPreferencesAdd, {
                                    code: act.code,
                                    description: act.description
                                  }, null, 8, ["code", "description"])
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_buttonGroup, {
                                    class: "mleft-06",
                                    styles: "pad-m"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_svg_item, {
                                        icon: "star",
                                        styles: "size-s main-l",
                                        style: {"margin-top":"-0.4rem"}
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["modelValue", "openOn"]))
                            : _createCommentVNode("", true)
                        ]),
                        (isTemplateStatus.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(act.alerts, (alert, index) => {
                                return (_openBlock(), _createBlock(_component_text_item, {
                                  key: index,
                                  txt: '! ' + alert,
                                  styles: "font-s main-alert",
                                  class: "linebreak"
                                }, null, 8, ["txt"]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (act.code)
                          ? (_openBlock(), _createBlock(_component_text_item, {
                              key: 1,
                              txt: act.description,
                              styles: "font-s main-m",
                              class: "linebreak cursor-sel",
                              style: {"cursor":"default"}
                            }, null, 8, ["txt"]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ], 4),
                  _createElementVNode("div", {
                    style: _normalizeStyle('grid-area:' + (actIndex + 2) + '/ amount;'),
                    class: "row-top"
                  }, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_41, [
                        (isTemplateStatus.value && (act.isFeeEditable || !act.code))
                          ? (_openBlock(), _createBlock(_component_inputBox, {
                              key: 0,
                              style: {"width":"4rem"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_inputLineNew2, {
                                  modelValue: act.fee,
                                  "onUpdate:modelValue": ($event: any) => ((act.fee) = $event),
                                  onKeydown: _unref(gen).onlyNumber,
                                  onPaste: _unref(gen).onlyNumber,
                                  onBlur: ($event: any) => (updateFee(act))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown", "onPaste", "onBlur"])
                              ]),
                              _: 2
                            }, 1024))
                          : (_openBlock(), _createBlock(_component_text_item, {
                              key: 1,
                              txt: parseFloat(act.amount).toFixed(2),
                              styles: "main-m"
                            }, null, 8, ["txt"])),
                        _createVNode(_component_text_item, {
                          txt: " €",
                          styles: "main-m",
                          class: "mleft-04"
                        })
                      ]),
                      (act.actClass === '1')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('patient.document.luBillAddon.withSupplement'),
                              styles: "main-m font-s",
                              class: "txt-primary"
                            }, null, 8, ["txt"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 4),
                  (isTemplateStatus.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        style: _normalizeStyle('grid-area:' + (actIndex + 2) + '/ trash;'),
                        class: "row-top"
                      }, [
                        _createVNode(_component_buttonGroup, {
                          class: "mleft-04 mtop-01",
                          onClick: ($event: any) => (deleteSingleLuAct(act))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_svg_item, {
                              icon: "trash",
                              styles: "main-l size-m"
                            })
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ], 4))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createVNode(_component_text_item, {
                txt: currLuBill.value.totalAmount + ' €',
                styles: "font-mBold",
                class: "pad-m mleft-auto mright-10"
              }, null, 8, ["txt"])
            ])
          ]),
          _createVNode(_component_text_item, {
            txt: _unref(t)('patient.document.luBill.additionalInfo'),
            class: "mtop-25",
            styles: "font-mBold"
          }, null, 8, ["txt"]),
          (isTemplateStatus.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                _createVNode(_component_dropdownBox, {
                  modelValue: dropd2.value,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((dropd2).value = $event)),
                  openOn: "additionalInfo"
                }, {
                  dropd: _withCtx(() => [
                    _createElementVNode("div", _hoisted_45, [
                      _createVNode(_component_item_scroll, { class: "h-full" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(interopLuStore).interopLuData.luBillAdditionalInfo, (info, index) => {
                            return (_openBlock(), _createBlock(_component_listGroup, {
                              key: index,
                              styles: "pad-s",
                              onClick: ($event: any) => (updateLuBillAdditionalInfo(info))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_46, [
                                  _createVNode(_component_text_item, {
                                    class: "mleft-06",
                                    style: {"min-width":"1.4rem"},
                                    txt: info.code
                                  }, null, 8, ["txt"]),
                                  _createVNode(_component_text_item, {
                                    class: "mleft-06 linebreak",
                                    txt: info.description,
                                    styles: "main-m"
                                  }, null, 8, ["txt"])
                                ])
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_buttonGroup, {
                      styles: "bg-white border-vl",
                      class: "psides-10"
                    }, {
                      default: _withCtx(() => [
                        (currLuBill.value.additionalInfo)
                          ? (_openBlock(), _createBlock(_component_text_item, {
                              key: 0,
                              txt: getAdditionalInfoText(currLuBill.value.additionalInfo),
                              class: "btn-text-dimensions",
                              styles: "main-m"
                            }, null, 8, ["txt"]))
                          : (_openBlock(), _createBlock(_component_svg_item, {
                              key: 1,
                              icon: "plus",
                              styles: "main-l size-m",
                              style: {"margin-top":"0.15rem","margin-bottom":"0.16rem"}
                            }))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (currLuBill.value.additionalInfo)
                  ? (_openBlock(), _createBlock(_component_buttonGroup, {
                      key: 0,
                      class: "mleft-04 mtop-01",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (updateLuBillAdditionalInfo(null)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_svg_item, {
                          icon: "trash",
                          styles: "main-l size-m"
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}
}

})